// Function to set a cookie
export const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `; expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

// Function to get a cookie
export const getCookie = (name: string) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  const cookie = cookies.find((cookieString) => cookieString.startsWith(nameEQ));
  return cookie ? cookie.substring(nameEQ.length) : null;
};

// Function to clear a cookie
export const clearCookie = (name: string) => {
  document.cookie = `${name}=; Max-Age=-99999999;`;
};
